import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (
  typeof window !== 'undefined' &&
  window.location.protocol === 'https:' &&
  window.location.hostname === 'angelfans.com.br'
) {
  window.location.replace(`https://www.angelfans.com.br${window.location.pathname}${window.location.search}${window.location.hash}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const googleClientId = String(process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
root.render(
  <React.StrictMode>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
